import { useVideoCallsStore } from "~/stores/videoCalls";

export default defineNuxtPlugin({
  name: "video-call-unload-guard",
  setup() {
    const videoCallsStore = useVideoCallsStore();
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (videoCallsStore.phase !== "active") return;

      event.preventDefault();
      event.returnValue = true;
    };
    let guardEnabled = false;

    watch(
      () => videoCallsStore.phase === "active",
      (isActive) => {
        if (isActive === guardEnabled) return;

        guardEnabled = isActive;
        if (isActive) {
          window.addEventListener("beforeunload", handleBeforeUnload);
        } else {
          window.removeEventListener("beforeunload", handleBeforeUnload);
        }
      },
      { immediate: true },
    );
  },
});
